import React from 'react';
import SelectField from '../../forms/SelectField';
import { toSelectionFormat } from '../../../lib/collection.utils';

const EventArtistInputs = ({ onInput, data, dependencies }) => (
    <React.Fragment>
        <div className="ckp-admin-grid-column">
            <SelectField
                name="artistIds"
                label="Select Artist Groups"
                onChange={onInput}
                value={data.artistIds}
                multiple={true}
                items={toSelectionFormat(dependencies.artists)}
            />
            or / and
            <SelectField
                name="eventIds"
                label="Copy Artists from Event"
                onChange={onInput}
                value={data.eventIds}
                multiple={true}
                items={toSelectionFormat(dependencies.events)}
            />
        </div>
    </React.Fragment>
);

export default EventArtistInputs;
